import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import VirtualList from '../virtual-list/virtual-list'
import virtualListPropType from '../virtual-list/virtual-list-prop-type'

import styles from './select.module.css'

const propTypes = {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
    open: PropTypes.bool,
    virtual: virtualListPropType
}

function OptionList(props) {
    const { children, virtual } = props

    const listClassName = cx('t3sel-dropdown-list', styles['options-list-items'], {
        [styles['virtual-list']]: virtual
    })
    return (
        <ul className={listClassName}>
            {virtual ? <VirtualList settings={virtual}>{children}</VirtualList> : children}
        </ul>
    )
}

OptionList.propTypes = propTypes

export default OptionList
